export default "__VITE_ASSET__5334fe12__"